import { Kpi } from "../../components/ui/Kpi";
import type { PortfolioSnapshotResponse } from "../../lib/api";
import { formatPercent, formatUsdcCompact } from "../../lib/format";
import { computeBlendedApy } from "./blendedApy";

export function PortfolioKpis({ data }: { data: PortfolioSnapshotResponse }) {
	const blendedApy = computeBlendedApy(data.positions, data.totalValueUsdcRaw);
	const hasValue = BigInt(data.totalValueUsdcRaw) > 0n;
	return (
		<div className="grid grid-cols-2 gap-3 md:grid-cols-4">
			<Kpi label="Total" value={formatUsdcCompact(data.totalValueUsdcRaw)} />
			<Kpi label="Positions" value={data.positionCount} />
			<Kpi
				label="Blended APY"
				value={hasValue ? formatPercent(blendedApy) : "—"}
				tone="positive"
				hint="USDC-value weighted (cash counted at 0%)"
			/>
			<Kpi
				label="Unpriced"
				value={data.unquotedEntries.length}
				tone={data.unquotedEntries.length === 0 ? "muted" : "neutral"}
			/>
		</div>
	);
}
